module.exports = __webpack_public_path__ + "./docs/img/icon-var.3d00bad6096169adbaf30659622abce1.svg";